export function Header() {
  return (
    <h1 style={{textAlign: 'center', marginBottom: '48px'}}>
      <img src="/images/logo.svg" alt="Microcred seeker provider portal" />
    </h1>
  );
}
